module.exports = __webpack_public_path__ + "img/kiley-reid.989b302a.png";